import { Injectable, Inject } from '@angular/core';
import { User } from "../model/user";
import { Observable, Subject } from "rxjs/Rx";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import { Http } from "@angular/http";
import { firebaseConfig } from '../../../environments/firebase.config';

@Injectable()
export class UserService {
    sdkdb: any;

    constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp,
        private http: Http) {
        this.sdkdb = fb.database().ref();
    }

    findAllUsers(): Observable<User[]> {

        return this.db.list('users')
            .map(User.fromJsonList)

    }

    // findUserRest(uid: string): Observable<any> {

    //     const url = `${firebaseConfig.databaseURL}/users/${uid}.json`;
    //     console.log("url = ", url)
    //     return this.http.get(url);
    
    //     USET IT LIKE THIS
    //     this.usersService.findUserRest(this.saveService.getUserId()).subscribe(res => {
    //         console.log('%%%%%%%%%%%%55 res = ', res)
    //         console.log('%%%%%%%%%%%%55 res = ', res._body)
    //       })
    // }

    findUserByEmail(email: string): Observable<User> {
        return this.db.list('users', {
            query: {
                orderByChild: 'email',
                equalTo: email
            }
        })
            .map(results => User.fromJson(results[0]));
    }

    findUserByUserId(uid: string): Observable<User> {
        return this.db.object(`users/${uid}`)
            .map(results => User.fromJson(results))
            .take(1);
    }

    getNewUserKey() {
        return this.sdkdb.child('users').push().key;
    }

    createNewUser(uid: string, user: any): Observable<any> {

        const userToSave = Object.assign({}, user, { uid });

        const newUserKey = this.getNewUserKey();

        let dataToSave = {};

        dataToSave["users/" + newUserKey] = userToSave;
        dataToSave[`usersPerInstitution/${uid}/${newUserKey}`] = true;

        return this.firebaseUpdate(dataToSave);
    }

    firebaseUpdate(dataToSave) {
        const subject = new Subject();
        console.log("dataToSave User = ", dataToSave)

        this.sdkdb.update(dataToSave)
            .then(
            val => {
                subject.next(val);
                subject.complete();

            },
            err => {
                subject.error(err);
                subject.complete();
            }
            );

        return subject.asObservable();
    }

    saveUser(uid: string, user): Observable<any> {
        const userToSave = Object.assign({}, user);
        delete (userToSave.$key);

        let dataToSave = {};
        dataToSave[`users/${uid}`] = userToSave;

        return this.firebaseUpdate(dataToSave);

    }


    // On fait le delete avec un appel REST pour faire changement lol
    deleteUser(userId: string): Observable<any> {

        const url = firebaseConfig.databaseURL + '/users/' + userId + '.json';
        console.log("url = ", url)
        return this.http.delete(url);

    }


    requestClientDeletion(clientId: string, courseId: string) {
        this.sdkdb.child('queue/tasks').push({ clientId, courseId })
            .then(
            () => alert('client deletion requested !')
            );
    }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/services/user.service.ts